module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "destination-container",
    style: ({
      'min-width': _vm.minWidth
    })
  }, [_c('img', {
    staticClass: "destination-icon",
    class: {
      'destination-icon_clickable': !_vm.canUpdate
    },
    attrs: {
      "src": _vm.destinationImage
    },
    on: {
      "click": function($event) {
        return _vm.$emit('selectedDestination', _vm.destination)
      },
      "mouseover": _vm.hover,
      "mouseout": _vm.hoverOut
    }
  })]), _vm._v(" "), (_vm.selected && (_vm.canUpdate || _vm.showUE)) ? _c('div', {
    staticClass: "inline"
  }, [(_vm.showPopup) ? _c('div', {
    staticClass: "popover",
    attrs: {
      "transition": "fade"
    },
    on: {
      "mouseover": _vm.hoverOnPopover,
      "mouseout": _vm.hoverOffPopover
    }
  }, [_c('div', {
    staticClass: "popover-text"
  }, [_vm._v(_vm._s(_vm.UEText))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showInput) ? _c('div', {
    staticClass: "inline"
  }, [(_vm.showMRM_ID) ? _c('div', {
    staticClass: "data-input"
  }, [_c('label', [_vm._v("MRM ID:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mrmId),
      expression: "mrmId"
    }],
    staticClass: "mrmId-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mrmId)
    },
    on: {
      "keypress": _vm.validateNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mrmId = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7484d8ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/MVPD.vue
// module id = 1951
// module chunks = 0